import { api } from './client';

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

export async function changePassword(request: ChangePasswordRequest): Promise<{ error: string | null }> {
  const { error } = await api.put('/api/auth/password', request);
  return { error };
}
